import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { useMe } from "@/api/auth";
import { PageHeader } from "@/components/shell/PageHeader";

export const Route = createFileRoute("/_app/settings")({ component: SettingsLayout });

function SettingsLayout() {
  const me = useMe();
  const tabs = [
    { to: "/settings/tokens", label: "Access tokens" },
    ...(me.data?.user.role === "admin" ? [{ to: "/settings/team", label: "Team" }] : []),
  ] as const;
  return (
    <>
      <PageHeader title="Settings" />
      <div className="mx-auto flex max-w-5xl gap-8 px-6 py-5">
        <nav className="w-40 shrink-0 space-y-0.5">
          {tabs.map((t) => (
            <Link
              key={t.to}
              to={t.to}
              className="block rounded-md px-2 py-1.5 text-sm text-muted-foreground hover:bg-muted"
              activeProps={{ className: "bg-accent text-accent-foreground" }}
            >
              {t.label}
            </Link>
          ))}
        </nav>
        <div className="min-w-0 flex-1">
          <Outlet />
        </div>
      </div>
    </>
  );
}
